module.exports = __webpack_public_path__ + "static/media/03-14.432f68cb.png";